import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LookupService } from '../services/lookup.service';

// This method is used to auth guard
export const authGuard: CanActivateFn = async (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getAccessToken();
  const isLoggedIn = authService.isLoggedIn();
  const lovService = inject(LookupService);
  
  if (!token || !isLoggedIn) {
    authService.setRedirectUrl(state.url);
    router.navigate(['/unauthorized']);
    return false;
  }
  //Clear cache on every route activation
  lovService.clearCache();
  return true;
};
